import { createSelector } from '@reduxjs/toolkit';

import {
  type DiceGameTileType,
  type TileBoardDataType,
} from '@/common/types/dice-game';

import { type RootState } from '../store';

const selectMainGameTileList = (state: RootState): DiceGameTileType[] =>
  state.diceGame.board;
const selectMiniGameTileList = (
  state: RootState,
): Array<number | string> | undefined => state.diceGame.miniGame?.board;

const selectMiniGameReward = createSelector(
  (
    state: RootState,
  ): Array<{ tgem: number } | { str: number } | string> | undefined =>
    state.diceGame.miniGame?.reward,
  (reward): number | undefined => {
    if (reward) {
      return reward.reduce(
        (prev, current) => Object.values(current)[0] + prev,
        0,
      );
    }
  },
);

const selectMainAndMiniGameTileList = createSelector(
  [selectMainGameTileList, selectMiniGameTileList],
  (
    mainTileList: DiceGameTileType[],
    miniGameTileList: Array<number | string> | undefined,
  ): TileBoardDataType[] =>
    mainTileList.map((mainGameTileData, index) => ({
      mainGameTileData,
      miniGameTileData: miniGameTileList ? miniGameTileList[index] : undefined,
    })),
);

export { selectMainAndMiniGameTileList, selectMiniGameReward };
